import { connect } from 'react-redux';
//import MessageFeed from './components/messageFeed';

const MessageFeed = require('./components/messageFeed.js').default;

import { DialogReduxProvider } from './providers/DialogReduxProvider';

const mapStateToFeedProps = (state: any): any => {
    return DialogReduxProvider.mapStateToFeedProps(state);
}

const mapDispatchToFeedProps = (dispatch: Function, props: any): any => {
    return { 
        editMessage: (id: number) => { props.edit(id); },
        ...DialogReduxProvider.createMapDispatchToFeedProps(props.service)(dispatch)
    };
}

export default connect(mapStateToFeedProps, mapDispatchToFeedProps)(MessageFeed); 